export class Font {
    private _fontName: string;
    private _fontType: string;

    //not needed in TypeScript, can be used with WebFontLoader as information about font source: custom, google, etc
    private _fontStyle: string;


    constructor(fontName: string, fontStyle: string, fontType: string) {
        this._fontName = fontName;
        this._fontStyle = fontStyle;
        this._fontType = fontType;
    }


    //HTML5 not working, testStrings with WebFontLoader can be used instead
    public hasGlyphs(str: string): boolean {
        return true;
    }

    get fontType(): string {
        return this._fontType;
    }
    get fontStyle(): string {
        return this._fontStyle;
    }
    get fontName(): string {
        return this._fontName;
    }

    /**
     * Additional web-oriented parameters
     */
    public isLoaded: boolean = false;
    public fontFamily: string;
    public styleSheet: CSSStyleSheet;
    public url: string;
    public cssRuleIndex: number;

}